export const PAGES = {
  aboutUs: {
    default: {
      title: 'About Us',
      slug: 'about-us',
    },
    boardMembers: {
      title: 'Echo Lacombe Association Board Members',
      titleNav: 'Board Members',
      slug: 'board-members',
    },
    termsOfReference: {
      title: 'Echo Lacombe Association Terms of Reference',
      titleNav: 'Terms of Reference',
      slug: 'terms-of-reference',
    },
  },
  business: {
    default: {
      title: 'Business',
      slug: 'business',
    },
    downtownStorefrontEnhancementProgram: {
      title: 'Downtown Storefront Enhancement Program',
      slug: 'downtown-storefront-enhancement-program',
    },
    sponsorship: {
      title: 'Sponsorship',
      titleNav: 'Sponsorship Inquiries',
      slug: 'sponsorship',
    },
    radioCoopAdvertising: {
      title: 'Radio Co-Op Advertising',
      slug: 'radio-coop-advertising',
    },
  },
  community: {
    default: {
      title: 'Community',
      slug: 'community',
    },
    communityGrants: {
      title: 'Community Grants',
      slug: 'community-grants',
    },
    foodRescue: {
      title: 'Echo Food Rescue',
      slug: 'food-rescue',
    },
  },
  media: {
    default: {
      title: 'Media',
      slug: 'media',
    },
    gallery: {
      title: 'Gallery',
      slug: 'gallery',
    },
    news: {
      title: 'News Releases',
      slug: 'news-releases',
    },
  },
};

export const FORM_LINKS = {
  community: 'https://forms.gle/cVxt2wT8oJrjbaGp8',
  sponsorship: 'https://forms.gle/6RLi1kEL8DHJiDqy5',
}